/** Gap kept between the cursor (or the container edge) and the tooltip. */
const TOOLTIP_OFFSET = 12;

type Placement = 'above-center' | 'below-right';

type PositionArgs = {
  tooltip: HTMLDivElement;
  container: HTMLElement;
  point: { x: number; y: number };
  size: { width: number; height: number };
  placement: Placement;
};

/**
 * Place `tooltip` relative to `point` and clamp it inside `container`, so the
 * map's `overflow: hidden` never truncates it. Shared by every map tooltip so
 * the edge handling cannot drift between them.
 */
export function positionMapTooltip({
  tooltip,
  container,
  point,
  size,
  placement,
}: PositionArgs): void {
  const { clientWidth, clientHeight } = container;

  let left = placement === 'above-center' ? point.x - size.width / 2 : point.x + TOOLTIP_OFFSET;
  let top =
    placement === 'above-center'
      ? point.y - size.height - TOOLTIP_OFFSET
      : point.y + TOOLTIP_OFFSET;

  if (left + size.width > clientWidth - TOOLTIP_OFFSET) {
    left = clientWidth - size.width - TOOLTIP_OFFSET;
  }
  if (left < TOOLTIP_OFFSET) left = TOOLTIP_OFFSET;

  // Not enough room on the preferred side — flip to the other side of the cursor.
  if (top < TOOLTIP_OFFSET) top = point.y + TOOLTIP_OFFSET;
  if (top + size.height > clientHeight - TOOLTIP_OFFSET) {
    top = clientHeight - size.height - TOOLTIP_OFFSET;
  }
  if (top < TOOLTIP_OFFSET) top = TOOLTIP_OFFSET;

  tooltip.style.left = `${left}px`;
  tooltip.style.top = `${top}px`;
}
